module.exports = __webpack_public_path__ + "static/media/revert15s.d32e0524.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/revert15s.svg
// module id = 1582
// module chunks = 1